import { authApi } from '@jq4race/api-client';

import type { AuthRepository } from '../../domain/ports/auth-repository';

export const httpAuthRepository: AuthRepository = {
  login: authApi.login,
  logout: authApi.logout,
};
